import queryString from 'query-string';

export function getQueryParam(key) {
  const query = window.location.search.substring(1);
  const params = query.split('&');
  for (let i = 0; i < params.length; i += 1) {
    const pair = params[i].split('=');
    if (decodeURIComponent(pair[0]) === key) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}

export function getQueryStringFromObject(object) {
  return Object.entries(object)
    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
    .join('&');
}

export function getFullUrl(url) {
  if (url && url[0] === '/') {
    return window.vueAppConfig.publicPath + url.slice(1);
  }
  return window.vueAppConfig.publicPath;
}

export function updateUrl(params) {
  const filteredParams = {};

  Object.keys(params).forEach((key) => {
    if (params[key] && typeof params[key] !== 'object') {
      filteredParams[key] = params[key];
    }
  });

  const query = queryString.stringify(filteredParams);
  let url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  if (query) {
    url += `?${query}`;
  }

  if (window.location.href !== url) {
    window.history.pushState(params, document.title, url);
  }
}

export function getDomainName() {
  const parts = window.location.hostname.split('.');
  if (parts.length > 2) {
    return `.${window.location.hostname.split('.').slice(1).join('.')}`;
  }
  return `.${window.location.hostname}`;
}
